import { mergeObjectTypes } from '../cacheHelpers';

const Permissions = {
  merge: mergeObjectTypes
};

export default Permissions;
